/**
 * Point d'entrée React monté dans le shadow DOM de <propelsia-gift-card> (ou dans un shadow root
 * imbriqué en mode modal). Réutilise tel quel le `PurchaseTunnel` de shared-components — comme le
 * widget booking réutilise `BookingTunnel`. Le captcha (Cap.js) est géré dans `createGiftCardCallbacks`.
 */

import { useMemo, type ReactElement } from 'react';
import { PurchaseTunnel, createGiftCardCallbacks, type GiftCardCallbacks } from '@cfixe-monorepo/shared-components';

export interface GiftCardRootProps {
  slug: string;
  onCompleted: (voucherUuid: string) => void;
  /** Locale BCP-47 (attribut `lang` du widget) pour le formatage montants/téléphone. Défaut fr-FR. */
  locale?: string;
  /** Ce widget a réservé le retour Stripe de la page (un seul widget peut le reprendre). */
  handleRedirectReturn: boolean;
}

export function GiftCardRoot({ slug, onCompleted, locale, handleRedirectReturn }: GiftCardRootProps): ReactElement {
  const callbacks = useMemo((): GiftCardCallbacks => createGiftCardCallbacks(slug), [slug]);

  return (
    <PurchaseTunnel
      slug={slug}
      callbacks={callbacks}
      onCompleted={onCompleted}
      locale={locale}
      handleRedirectReturn={handleRedirectReturn}
    />
  );
}
